import { z } from 'zod';

/**
 * 🎨 PRODUCT LAYOUT SCHEMA
 * Defines how products are displayed in the catalog.
 */
export const ProductLayoutSchema = z.enum(['standard', 'grid', 'list', 'compact']).default('standard');

export type ProductLayout = z.infer<typeof ProductLayoutSchema>;
